﻿export enum VersionTypes {
    api,
    ui
}